import { lazy } from 'react';
import Loadable from "../Components/Loadable";
import Landing from "../pages/landing";
import AnimateButton from "../Components/@extended/AnimateButton";
import {Button} from "@mui/material";
import {Auth} from "aws-amplify";
import {LoginOutlined} from "@ant-design/icons";
import React from ".";
import CommonLayout from '../layout/CommonLayout';
import OAuthPopup from "../OAuth2/OAuthPopup";
import GettingStarted from "../pages/getting-started/getting-started";

// const FAQPage = Loadable(lazy(() => import ('../pages/faq/faq')));
const SuccessfulSignup = Loadable(lazy(() => import('../pages/auth/successful-signup')));
const SuccessfulSignupXero = Loadable(lazy(() => import('../pages/auth/successful-signup-xero')));
const SignUpWithXero = Loadable(lazy(() => import('../pages/pricing/signup-with-xero')))
const GettingStartedPage = Loadable(lazy(() => import('../pages/getting-started/getting-started')))


function LoginButton(props){
    console.log("Going to login")
    return (
        <>
            <AnimateButton>
                <Button size="large"
                        onClick={() => Auth.federatedSignIn()}
                        endIcon={<LoginOutlined />}
                        variant="contained"
                >Sign in
                </Button>
            </AnimateButton>
        </>
    )
}

const LoggedOutRoutes = {
    path: '/',
    element: <CommonLayout layout='infopage'/>,
    // element: <Landing LoginButton={<LoginButton />} />,
    children: [
        // {
        //     path: 'faq',
        //     element: <FAQPage />
        // },
        {
            path: 'getting-started',
            element: <GettingStartedPage />
        },
        // {
        //     path: 'callback',
        //     element: <OAuthPopup />
        // },
        // {
        //     path: 'signup-success:id',
        //     element: <SuccessfulSignupXero />
        // },
        // {
        //     path: 'signup-success',
        //     element: <SuccessfulSignupXero />
        // },
        // {
        //     path: 'signup-with-xero',
        //     element: <SignUpWithXero />
        // }
    ]
}

export default LoggedOutRoutes;